import { useId } from "react";

export default function RectSwitch({
  checked,
  onChange,
  disabled = false,
  id,
}) {
  const autoId = useId();
  const switchId = id ?? autoId;

  return (
    <label
      htmlFor={switchId}
      className={`inline-flex select-none ${
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
      }`}
    >
      {/* Hidden checkbox */}
      <input
        id={switchId}
        type="checkbox"
        className="peer sr-only"
        checked={checked}
        onChange={(e) => onChange?.(e.target.checked)}
        disabled={disabled}
      />

      {/* Track & Thumb */}
      <span
        className={`
          relative block w-20 h-[35px] bg-gray-300 overflow-hidden leading-none
          transition-colors duration-200
          peer-checked:bg-blue-100/50
          
          /* The Slider Thumb */
          before:content-[''] before:absolute before:top-0 before:left-0
          before:h-[35px] before:w-10 before:bg-[#333333]
          before:transition-all before:duration-200
          
          /* Blue Color when Checked */
          peer-checked:before:translate-x-10 
          peer-checked:before:bg-blue-600
        `}
      />
    </label>
  );
}